import React from 'react';
import * as LucideIcons from 'lucide-react';
import './CustomFocus.css';

// Curated list of icons suitable for custom focuses
const CURATED_ICONS = [
  'Pencil',
  'FileText',
  'Users',
  'User',
  'Heart',
  'Star',
  'Sparkles',
  'Lightbulb',
  'BookOpen',
  'Map',
  'Compass',
  'Target',
  'Zap',
  'Flame',
  'Shield',
  'Sword',
  'Crown',
  'Gem',
  'Moon',
  'Sun',
  'Cloud',
  'Mountain',
  'TreePine',
  'Home',
];

/**
 * IconPicker - Grid of Lucide icons for selection
 *
 * Props:
 * - value: Currently selected icon name
 * - onChange: Callback when icon is selected
 */
export default function IconPicker({ value, onChange }) {
  return (
    <div className="icon-picker">
      <label className="icon-picker-label">Icon</label>
      <div className="icon-picker-grid">
        {CURATED_ICONS.map((iconName) => {
          const IconComponent = LucideIcons[iconName];
          if (!IconComponent) return null;

          return (
            <button
              key={iconName}
              type="button"
              className={`icon-picker-btn ${value === iconName.toLowerCase() ? 'selected' : ''}`}
              onClick={() => onChange(iconName.toLowerCase())}
              title={iconName}
            >
              <IconComponent size={20} />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { CURATED_ICONS };
